var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatIconTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8467_3840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9688 9.15918H2.82256C2.21942 9.15918 1.73047 9.64813 1.73047 10.2513V17.0769C1.73047 17.68 2.21942 18.169 2.82256 18.169H4.09667C5.60453 18.169 6.8269 19.3914 6.8269 20.8992C6.8269 22.4071 5.60453 23.6295 4.09667 23.6295H2.82256C2.21942 23.6295 1.73047 24.1184 1.73047 24.7216V31.5472C1.73047 32.1504 2.21941 32.6393 2.82256 32.6393H11.9688M11.9688 9.15918H37.2235C37.8266 9.15918 38.3156 9.64813 38.3156 10.2513V31.5472C38.3156 32.1504 37.8266 32.6393 37.2235 32.6393H11.9688M11.9688 9.15918V13.3166M11.9688 32.6393V28.2832M11.9688 18.169V23.6295",
    stroke: "#1E1E20",
    strokeWidth: 3.32592,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8467_3840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.911,
    height: 39.911,
    fill: "white",
    transform: "translate(0.0664062 0.844727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatIconTicket);
export default __webpack_public_path__ + "static/media/gat-icon-ticket.ffcd0f47c40228b31ae26614bf395283.svg";
export { ForwardRef as ReactComponent };